import { render } from "./ColorRenderer.vue?vue&type=template&id=2423eb74&scoped=true"
import script from "./ColorRenderer.vue?vue&type=script&lang=js"
export * from "./ColorRenderer.vue?vue&type=script&lang=js"

import "./ColorRenderer.vue?vue&type=style&index=0&id=2423eb74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2423eb74"]])

export default __exports__